export default {"src":"/_next/static/media/timer-clock.e1e7baac.svg","height":20,"width":20};